import React, { useState, useEffect } from "react";
import {
  getTeamMembers,
  addTeamMember,
  updateTeamMember,
  deleteTeamMember,
  uploadImage,
} from "./firestoreServices";

const TeamDashboard = () => {
  const [members, setMembers] = useState([]);
  const [form, setForm] = useState({
    img: "",
    ar: { name: "", role: "", bio: "" },
    en: { name: "", role: "", bio: "" },
  });
  const [file, setFile] = useState(null);
  const [editId, setEditId] = useState(null);

  useEffect(() => {
    load();
  }, []);
  const load = async () => {
    setMembers(await getTeamMembers());
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let imgUrl = form.img;
    if (file) imgUrl = await uploadImage(file); // رفع الصورة لو موجودة

    const data = { ...form, img: imgUrl };
    if (editId) await updateTeamMember(editId, data);
    else await addTeamMember(data);

    setForm({
      img: "",
      ar: { name: "", role: "", bio: "" },
      en: { name: "", role: "", bio: "" },
    });
    setFile(null);
    setEditId(null);
    load();
  };

  const handleEdit = (m) => {
    setForm(m);
    setEditId(m.id);
    window.scrollTo(0, 0);
  };
  const handleDelete = async (id) => {
    await deleteTeamMember(id);
    load();
  };

  return (
    <div className="dashboard-container">
      <h2 className="page-title">إدارة فريق العمل</h2>

      <div className="admin-card">
        <h3 className="form-title">
          {editId ? "تعديل عضو" : "إضافة عضو جديد"}
        </h3>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>الصورة الشخصية</label>
            <input
              type="file"
              onChange={(e) => setFile(e.target.files[0])}
              style={{ marginBottom: "10px" }}
            />
            <input
              className="admin-input"
              placeholder="أو رابط صورة خارجي"
              value={form.img}
              onChange={(e) => setForm({ ...form, img: e.target.value })}
              dir="ltr"
            />
          </div>

          <div className="form-grid">
            <div>
              <h4 style={{ marginBottom: "10px", color: "green" }}>
                بيانات العربية
              </h4>
              <input
                className="admin-input"
                placeholder="الاسم"
                value={form.ar.name}
                onChange={(e) =>
                  setForm({ ...form, ar: { ...form.ar, name: e.target.value } })
                }
                style={{ marginBottom: "10px" }}
              />
              <input
                className="admin-input"
                placeholder="الوظيفة"
                value={form.ar.role}
                onChange={(e) =>
                  setForm({ ...form, ar: { ...form.ar, role: e.target.value } })
                }
                style={{ marginBottom: "10px" }}
              />
              <textarea
                className="admin-textarea"
                placeholder="نبذة"
                value={form.ar.bio}
                onChange={(e) =>
                  setForm({ ...form, ar: { ...form.ar, bio: e.target.value } })
                }
              />
            </div>
            <div>
              <h4 style={{ marginBottom: "10px", color: "blue" }}>
                English Details
              </h4>
              <input
                className="admin-input"
                placeholder="Name"
                value={form.en.name}
                onChange={(e) =>
                  setForm({ ...form, en: { ...form.en, name: e.target.value } })
                }
                style={{ marginBottom: "10px" }}
                dir="ltr"
              />
              <input
                className="admin-input"
                placeholder="Role"
                value={form.en.role}
                onChange={(e) =>
                  setForm({ ...form, en: { ...form.en, role: e.target.value } })
                }
                style={{ marginBottom: "10px" }}
                dir="ltr"
              />
              <textarea
                className="admin-textarea"
                placeholder="Bio"
                value={form.en.bio}
                onChange={(e) =>
                  setForm({ ...form, en: { ...form.en, bio: e.target.value } })
                }
                dir="ltr"
              />
            </div>
          </div>

          <button className="btn btn-primary" style={{ marginTop: "20px" }}>
            {editId ? "حفظ" : "إضافة"}
          </button>
          {editId && (
            <button
              type="button"
              onClick={() => {
                setEditId(null);
                setForm({
                  img: "",
                  ar: { name: "", role: "", bio: "" },
                  en: { name: "", role: "", bio: "" },
                });
              }}
              className="btn btn-secondary"
              style={{ marginTop: "20px", marginRight: "10px" }}
            >
              إلغاء
            </button>
          )}
        </form>
      </div>

      <div className="items-grid">
        {members.map((m) => (
          <div key={m.id} className="grid-item">
            <img
              src={m.img || "https://via.placeholder.com/150"}
              alt="Member"
              className="item-img"
            />
            <h3>{m.ar.name}</h3>
            <p style={{ color: "#c5a059", fontWeight: "bold" }}>{m.ar.role}</p>
            <div className="item-actions">
              <button
                onClick={() => handleEdit(m)}
                className="btn btn-secondary btn-action"
              >
                تعديل
              </button>
              <button
                onClick={() => handleDelete(m.id)}
                className="btn btn-danger btn-action"
              >
                حذف
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
export default TeamDashboard;
